
export const FETCH_PLAYLISTS_START = 'FETCH_PLAYLISTS_START';
export const FETCH_PLAYLISTS_SUCCESS = 'FETCH_PLAYLISTS_SUCCESS';
export const FETCH_PLAYLISTS_FAILURE = 'FETCH_PLAYLISTS_FAILURE';

export const SELECT_PLAYLIST = 'SELECT_PLAYLIST';

export const CREATE_PLAYLIST_START = 'CREATE_PLAYLIST_START';
export const CREATE_PLAYLIST_SUCCESS = 'CREATE_PLAYLIST_SUCCESS';
export const CREATE_PLAYLIST_FAILURE = 'CREATE_PLAYLIST_FAILURE';

export const DELETE_PLAYLIST_START = 'DELETE_PLAYLIST_START';
export const DELETE_PLAYLIST_SUCCESS = 'DELETE_PLAYLIST_SUCCESS';
export const DELETE_PLAYLIST_FAILURE = 'DELETE_PLAYLIST_FAILURE';

export const EXPORT_PLAYLIST_START = 'EXPORT_PLAYLIST_START';
export const EXPORT_PLAYLIST_SUCCESS = 'EXPORT_PLAYLIST_SUCCESS';
export const EXPORT_PLAYLIST_FAILURE = 'EXPORT_PLAYLIST_FAILURE';

export const FETCH_DEVICES_START = 'FETCH_DEVICES_START';
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS';
export const FETCH_DEVICES_FAILURE = 'FETCH_DEVICES_FAILURE';

export const SELECT_DEVICE = 'SELECT_DEVICE';
export const PAIR_NEW_DEVICE = 'PAIR_NEW_DEVICE';

export const SELECT_MEDIA_LIBRARY = 'SELECT_MEDIA_LIBRARY';

export const SUBMIT_CODE_START = 'SUBMIT_CODE_START';
export const SUBMIT_CODE_SUCCESS = 'SUBMIT_CODE_SUCCESS';
export const SUBMIT_CODE_FAILURE = 'SUBMIT_CODE_FAILURE';

export const FETCH_MEDIA_START = 'FETCH_MEDIA_START';
export const FETCH_MEDIA_SUCCESS = 'FETCH_MEDIA_SUCCESS';
export const FETCH_MEDIA_FAILURE = 'FETCH_MEDIA_FAILURE';

export const SELECT_MEDIA = 'SELECT_MEDIA';

export const UPLOAD_MEDIA_START = 'UPLOAD_MEDIA_START';
export const UPLOAD_MEDIA_SUCCESS = 'UPLOAD_MEDIA_SUCCESS';
export const UPLOAD_MEDIA_FAILURE = 'UPLOAD_MEDIA_FAILURE';

export const ATTACH_MEDIA_START = 'ATTACH_MEDIA_START';
export const ATTACH_MEDIA_SUCCESS = 'ATTACH_MEDIA_SUCCESS';
export const ATTACH_MEDIA_FAILURE = 'ATTACH_MEDIA_FAILURE';

export const SAVE_MEDIA_START = 'SAVE_MEDIA_START';
export const SAVE_MEDIA_SUCCESS = 'SAVE_MEDIA_SUCCESS';
export const SAVE_MEDIA_FAILURE = 'SAVE_MEDIA_FAILURE';

export const DELETE_MEDIA_START = 'DELETE_MEDIA_START';
export const DELETE_MEDIA_SUCCESS = 'DELETE_MEDIA_SUCCESS';
export const DELETE_MEDIA_FAILURE = 'DELETE_MEDIA_FAILURE';

export const DELETE_MEDIA_FROM_PLAYLIST_START = 'DELETE_MEDIA_FROM_PLAYLIST_START';
export const DELETE_MEDIA_FROM_PLAYLIST_SUCCESS = 'DELETE_MEDIA_FROM_PLAYLIST_SUCCESS';
export const DELETE_MEDIA_FROM_PLAYLIST_FAILURE = 'DELETE_MEDIA_FROM_PLAYLIST_FAILURE';

export const SELECT_DEVICE_BY_ID = 'SELECT_DEVICE_BY_ID';

export const SELECT_PLAYLIST_BY_ID = 'SELECT_PLAYLIST_BY_ID';

export const DELETE_DEVICE_START = 'DELETE_DEVICE_START';
export const DELETE_DEVICE_SUCCESS = 'DELETE_DEVICE_SUCCESS';
export const DELETE_DEVICE_FAILURE = 'DELETE_DEVICE_FAILURE';

export const UPDATE_DEVICE_START = 'UPDATE_DEVICE_START';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const UPDATE_DEVICE_FAILURE = 'UPDATE_DEVICE_FAILURE';

// Series art (#482)
export const FETCH_SERIES_ART_START = 'FETCH_SERIES_ART_START';
export const FETCH_SERIES_ART_SUCCESS = 'FETCH_SERIES_ART_SUCCESS';
export const FETCH_SERIES_ART_FAILURE = 'FETCH_SERIES_ART_FAILURE';

export const UPDATE_SERIES_ART_START = 'UPDATE_SERIES_ART_START';
export const UPDATE_SERIES_ART_SUCCESS = 'UPDATE_SERIES_ART_SUCCESS';
export const UPDATE_SERIES_ART_FAILURE = 'UPDATE_SERIES_ART_FAILURE';

export const UPLOAD_SERIES_ART_START = 'UPLOAD_SERIES_ART_START';
export const UPLOAD_SERIES_ART_SUCCESS = 'UPLOAD_SERIES_ART_SUCCESS';
export const UPLOAD_SERIES_ART_FAILURE = 'UPLOAD_SERIES_ART_FAILURE';

// Per-playlist series art (#482) — separate from the org-scoped
// series-art action types above so the playlist editor's toggle
// and the settings-view toggle can share a store without stomping
// on each other.
export const UPDATE_PLAYLIST_SERIES_ART_START = 'UPDATE_PLAYLIST_SERIES_ART_START';
export const UPDATE_PLAYLIST_SERIES_ART_SUCCESS = 'UPDATE_PLAYLIST_SERIES_ART_SUCCESS';
export const UPDATE_PLAYLIST_SERIES_ART_FAILURE = 'UPDATE_PLAYLIST_SERIES_ART_FAILURE';

export const UPLOAD_PLAYLIST_SERIES_ART_START = 'UPLOAD_PLAYLIST_SERIES_ART_START';
export const UPLOAD_PLAYLIST_SERIES_ART_SUCCESS = 'UPLOAD_PLAYLIST_SERIES_ART_SUCCESS';
export const UPLOAD_PLAYLIST_SERIES_ART_FAILURE = 'UPLOAD_PLAYLIST_SERIES_ART_FAILURE';

export const FETCH_SERIES_ART_SERVICE_TYPES_START = 'FETCH_SERIES_ART_SERVICE_TYPES_START';
export const FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS = 'FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS';
export const FETCH_SERIES_ART_SERVICE_TYPES_FAILURE = 'FETCH_SERIES_ART_SERVICE_TYPES_FAILURE';